<div class="wrapper">
  <app-header></app-header>
  <section class="section-overlay">
    <router-outlet></router-outlet>
  </section>
  <app-footer></app-footer>
</div>